module.exports = __webpack_public_path__ + "investmentSnapshotSlideoutAsset.b296f2b3133b8c9665ce055c605ab28e.png";